import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const FullPageLoader = ({ message = "Loading..." }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        bgcolor: "#f4f7fe",
        zIndex: 9999,
      }}
    >
      <CircularProgress size={40} thickness={4} sx={{ color: "#006dff" }} />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};

export default FullPageLoader;